import { HttpClient } from '@angular/common/http';
import { effect, inject, Injectable } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop'
import { map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SchedulerStepService } from '../step/scheduler-step.service';
import { FormatPipe } from '@app/pipes/format.pipe';
import { CalendarAvailabilityService } from '../calendarAvailability/calendarAvailability.service';
import { CategoriesService } from '../categories/categories.service';

@Injectable({
  providedIn: 'root'
})
export class Availabilities {

  private apiURL: string = environment.apiURL
  private availabilityEndPoint: string = environment.availabilityEndPoint
  private http = inject(HttpClient)
  private schedulerService = inject(SchedulerStepService)
  private categoriesService = inject(CategoriesService)
  private calendarAvailabilityrService = inject(CalendarAvailabilityService)
  
  private formatPipe = inject(FormatPipe)

  availabilityRessource = rxResource({ 
    request: () => {
      if(this.schedulerService.payload()['services'] == undefined || this.schedulerService.payload()['calendar'] !== undefined) {
        return {
          service: false,
          branchID: undefined
        }
      }
      return {
        service: {...this.categoriesService.ServiceInfo(this.schedulerService.payload()['services']), timezone: this.schedulerService.branchSelected().timeZone},
        branchID: this.schedulerService.branchSelected().branchID
      }
    },
    loader: ( {request} ) => (request.branchID === undefined) ? of(null): this.http.post<AvailabilitiesType[]>(`${this.apiURL}${this.formatPipe.transform(this.availabilityEndPoint, {'branchID': request.branchID})}`, request.service)
      .pipe(
      map(availabilityResponse => availabilityResponse )
    )
  })

  eff = effect( () => {
    if (!this.availabilityRessource.isLoading() && this.availabilityRessource.value() !== null)
      this.calendarAvailabilityrService.fetchcalendarAvailability.set(this.availabilityRessource.value()!)
  })

}
